module.exports = __webpack_public_path__ + "img/showGraph.1ba429e4.svg";